import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDarkMode, useDevMode } from "../../contexts/ThemeContext";
import { useTranslation } from "react-i18next";
import LoginForm from "../../components/Login/LoginForm";
import LoginImage from "../../components/Login/LoginImage";
import TwoFactorModal from "../../components/Modals/TwoFactorModal";
import TermsModal from "../../components/Modals/TermsModal";
import { useLoginData } from "../../hooks/useLoginData";
import { useDevModeLoginSetup } from "../../hooks/useDevModeLoginSetup";
import routing from "../../routing";
import { usePendingUser } from "../../contexts/PendingUserContext";
import { useAuth } from "../../contexts/AuthContext";
import "../../style/Login.css";

function Login() {
  const { darkMode } = useDarkMode();
  const { t } = useTranslation();
  const { registerDevAction, clearDevActions } = useDevMode();
  const navigate = useNavigate();

  const { pendingUser, setPendingUser, setTermsAccepted } = usePendingUser();
  const { login, logout } = useAuth();

  const [show2FA, setShow2FA] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const {
    email,
    setEmail,
    password,
    setPassword,
    passwordVisible,
    setPasswordVisible,
    isInvalid,
    loading,
    loginSuccess,
    setLoginSuccess,
    errorMessage,
    handleSubmit: submitLogin,
  } = useLoginData(setPendingUser);

  const handleSubmit = (event) => submitLogin(event, setShow2FA, handleVerificationSuccess);

  useDevModeLoginSetup(
    registerDevAction,
    clearDevActions,
    setEmail,
    setPendingUser,
    setLoginSuccess,
    setShow2FA,
  );

  const handleVerificationSuccess = () => {
    localStorage.setItem("email", email);
    setShow2FA(false);
    setShowTerms(true);
  };

  const handleTermsAccept = () => {
    setTermsAccepted(true);
    localStorage.setItem("termsAccepted", "true");

    if (pendingUser) {
      login(pendingUser);
      setPendingUser(null);
    }

    setShowTerms(false);
    navigate(routing.home.path);
  };

  const handleTermsDecline = () => {
    setShowTerms(false);
    setPendingUser(null);
    logout();
    setTermsAccepted(false);

    localStorage.removeItem("termsAccepted");
    localStorage.removeItem("dev_profile");
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("active_user_id");
    localStorage.removeItem("email");

    setEmail("");
    setPassword("");
  };

  return (
    <div className="login-page">
      <LoginForm
        darkMode={darkMode}
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        passwordVisible={passwordVisible}
        setPasswordVisible={setPasswordVisible}
        loading={loading}
        loginSuccess={loginSuccess}
        show2FA={show2FA}
        isInvalid={isInvalid}
        errorMessage={errorMessage}
        handleSubmit={handleSubmit}
        t={t}
      />

      <LoginImage darkMode={darkMode} t={t} />

      <TwoFactorModal
        open={show2FA}
        onClose={() => {}}
        onVerificationSuccess={handleVerificationSuccess}
        darkMode={darkMode}
      />

      <TermsModal
        open={showTerms}
        onClose={() => {}}
        onAccept={handleTermsAccept}
        onDecline={handleTermsDecline}
        darkMode={darkMode}
      />
    </div>
  );
}

export default Login;
